<template>
  <div>
    <el-form ref="form" :model="form" label-position="left" label-width="80px" size="mini">
      <el-form-item label="表名：">
        <el-input v-model="form.tableName" clearable style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item label="ID范围：">
        <el-input v-model="form.fromId" clearable style="width: 200px"></el-input>
        <span style="margin: 0 10px">-</span>
        <el-input v-model="form.toId" clearable style="width: 200px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="form.isGenerating" @click="onClickGenerateBtn()">开始生成</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      form: {
        tableName: "usable_id",
        fromId: bizutil.isProdEnv() ? 10000000 : 1000000,
        toId: bizutil.isProdEnv() ? 20000000 : 2000000,
        isGenerating: false,
      }
    }
  },

  methods: {
    async onClickGenerateBtn() {
      this.form.isGenerating = true;

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/generateRandomIds`,
          {
            tableName: this.form.tableName,
            fromId: this.form.fromId,
            toId: this.form.toId,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$alert(resData.message, "提示", {
          center: true,
          type: "error",
          callback: (action) => { },
        });

        this.form.isGenerating = false;
        return;
      }

      this.$alert("操作成功", "提示", {
        center: true,
        type: "success",
        callback: (action) => { },
      });

      this.form.isGenerating = false;
    }
  }
}
</script>